const Permissions = (permissions = []) => {
  const isEditorUser = permissions.includes(8);
  const isReaderRole = permissions.includes(12);
  const isEditorRoleBasic = permissions.includes(13);
  const isEditorRoleAdministrator = permissions.includes(14);
  const canAssignRole = isEditorRoleBasic || isEditorRoleAdministrator;

  const notEditor =
    permissions.length > 0 &&
    !isEditorUser &&
    !isEditorRoleBasic &&
    !isEditorRoleAdministrator &&
    isReaderRole;

  return {
    isEditorUser,
    isReaderRole,
    isEditorRoleBasic,
    isEditorRoleAdministrator,
    canAssignRole,
    notEditor,
  };
};

export default Permissions;
